<template>
  <svg xmlns="http://www.w3.org/2000/svg" ref="svg">
    <g :transform="transform" :style="{ 'stroke-width': strokeWidth }">
      <path :d="path"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "NPathLayer",
  props: {
    x: { type: Number },
    y: { type: Number },
    scaling: { type: Number },
    path: { type: String }
  },
  data() {
    return {
      strokeWidth: ""
    }
  },
  computed: {
    transform() {
      return "scale(" + this.scaling + " " + this.scaling + ") translate(" + (this.x / this.scaling) + " " + (this.y / this.scaling) + ")";
    },
  },
  mounted() {
    this.setStrokeWidth();
  },
  watch: {
    scaling() {
      this.setStrokeWidth();
    },
    path() {
      this.setStrokeWidth();
    }
  },
  methods: {
    setStrokeWidth() {
      const computedStrokeWidth = getComputedStyle(this.$refs.svg).strokeWidth;
      this.strokeWidth = !computedStrokeWidth ? "" : (parseFloat(computedStrokeWidth) / this.scaling + "px");
    }
  }
}
</script>

<style scoped>
svg {
  display: block;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
}
</style>
